import loadingImg from '../images/loading.gif';
import '../styles/Loading.scss';

function Loading() {
  return (
    <div className="loading">
      <img src={loadingImg} alt="loading"></img>
      <span>Loading...</span>
    </div>
  );
}

export default Loading;
